var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "broker-card"
  }, [_c("img", {
    staticClass: "broker-card_img",
    attrs: {
      src: _vm.url,
      alt: "card-img"
    }
  }), _c("p", [_vm._v(_vm._s(_vm.text))]), _c("img", {
    staticClass: "broker-card_comma",
    attrs: {
      src: require("@/assets/images/components/news-comma.png"),
      alt: "comma"
    }
  })]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };